module.exports = __webpack_public_path__ + "static/cloud-logo-b7ae2e2ca3f9a3a32c7ba2e40621686b.svg";